<div class="global-selection" [ngClass]="this.toolsService.navigationOnTop? 'top' : ''">
  <div class="global-selection__container">
    <div class="select_feature" (click)="this.globalSelectionService.setPointerAll()" [ngClass]="this.globalSelectionService.isPointerAll() ? 'active' : ''"></div>
    <div class="polygon_select" style="border-right: 1px solid white;" (click)="this.globalSelectionService.setBoxAll()" [ngClass]="this.globalSelectionService.isBoxAll() ? 'active' : ''"></div>
    <div class="circle_select" (click)="this.globalSelectionService.setCircleAll()" [ngClass]="this.globalSelectionService.isCircleAll() ? 'active' : ''"></div>
    <div class="clear_select" (click)="this.globalSelectionService.clearAllSelectedTools()" [ngClass]="displayCloseEventsButton() ? 'border_right' : ''"></div>
    <div class="home" (click)="this.globalSelectionService.changeExtent()" style="width: 44px;"></div>
  </div>

  <div *ngIf="displayCloseEventsButton()" class="global-selection__events-map">
    <footer class="footer">
      <div>
        <div>
          <span title="Active Map Event"> {{getActiveEvent()}} </span>
        </div>
      </div>
    </footer>
    <div title="Remove Active Map Event" class="clear_map_events" (click)="globalSelectionService.clearAllSelectedTools()"></div>
  </div>
</div>
